<script setup>
import {useReportOutput} from "@/components/report/outputs/useReportOutput";
import {ref, getCurrentInstance} from "vue";
import AuctionRepricer from "@/components/auction/auction-repricer.vue";
import OrderAddItemByAuction from "@/components/order/order-add-item-by-auction.vue";
import helpers from "@/lib/helpers";

const dialog = getCurrentInstance().proxy.$dialog

const props = defineProps({
  value: null,
  item: Object
})

const rp_btn = ref('secondary')
const add_btn = ref('secondary')
const state = ref(false)

const {v, extra} = useReportOutput(props)

const reprice = async () => {
  rp_btn.value = 'primary'
  const data = await dialog.showAndWait(AuctionRepricer, {url: props.value.display})

  if (data) {
    state.value = 'loading'
    try {
      await helpers.asyncAction(props.value.display, 'PUT', {
        noload: true,
        data
      })
      rp_btn.value = 'success'
      props.item.Price = data.eb_StartPrice
      props.item['Days Since Last Change'] = null
    } catch (e) {
      console.log('Exception', e)
      rp_btn.value = 'danger'
    } finally {
      state.value = false
    }
  } else {
    rp_btn.value = 'secondary'
  }
}

const add = async () => {
  add_btn.value = 'primary'
  const result = await dialog.showAndWait(OrderAddItemByAuction, {auction: props.value.raw, unit: '0.00', noQty: true})
  if (result)
    state.value = 'x'
  add_btn.value = 'secondary'
}

</script>

<template>
  <div class="d-flex" style="min-height: 31px">
    <b-spinner class="m-auto" small variant="primary" v-if="state === 'loading'"/>
    <font-awesome-icon size="xl" class="m-auto text-danger" :icon="['far', 'circle-xmark']" v-else-if="state === 'x'"/>

    <b-btn-group size="sm" v-else>
      <b-btn size="sm" :variant="rp_btn" @click="reprice" v-b-tooltip.hover title="Reprice">
        <font-awesome-icon :icon="['fas', 'dollar-sign']" />
      </b-btn>
      <b-btn size="sm" :variant="add_btn" @click="add">
        <font-awesome-icon :icon="['far', 'square-plus']" v-b-tooltip.hover title="Add to Order"/>
      </b-btn>
    </b-btn-group>
  </div>
</template>

<style scoped>

</style>